<style>
.tabs{
  display: grid;
  grid-template-columns: 33% 34% 33%;
  font-size: 16px;
}
.tab1{
  grid-column: 1;
  text-align: center;
  border-right: 1px gray solid;
  padding: 15px 0;
}
.tab2{
  grid-column: 2;
  text-align: center;
  border-right: 1px gray solid;
  padding: 15px 0;
}
.tab3{
  grid-column: 3;
  text-align: center;
  padding: 15px 0;
}
.selected{
  background-color: #333;
}

.manage-photo{
  text-align: center;
}
.manage-photo-pic{
  width: 89px;
  height: 89px;
  border-radius: 89px;
}
.dialog-title{
  text-align: center;
  font-size: 25px;
  margin-bottom: 40px;
}

.options{
  display: grid;
  grid-template-columns: auto auto;
  grid-template-rows: 45px 45px 45px 45px;
}
.option11{
  grid-column: 1;
  grid-row: 1;
}
.option21{
  grid-column: 2;
  grid-row: 1;
  text-align: right;
  padding-right: 10px;
}

.option12{
  grid-column: 1;
  grid-row: 2;
}
.option22{
  grid-column: 2;
  grid-row: 2;
  text-align: right;
  padding-right: 10px;
}

.option13{
  grid-column: 1;
  grid-row: 3;
}
.option23{
  grid-column: 2;
  grid-row: 3;
  text-align: right;
  padding-right: 10px;
}

.option14{
  grid-column: 1;
  grid-row: 4;
  border-top: 1px #777 solid;
  padding-top: 14px;
}
.option24{
  grid-column: 2;
  grid-row: 4;
  text-align: right;
  padding-right: 10px;
  padding-top: 14px;
  border-top: 1px #777 solid;
}

.circle{
  display: inline-block;
  border: 1px #777 solid;
  border-radius: 16px;
  width: 16px;
  height: 16px;
}

.user{
  display: grid;
  /* grid-template-columns: 51px auto 100px 20px; */
  grid-template-columns: 51px auto 100px;
  font-size: 18px;
  margin: 10px;
  align-items: center;
}
.user-pic{
  grid-column: 1;
}
.photo{
  width: 49px;
  height: 49px;
  border-radius: 49px;
}
.user-name{
  grid-column: 2;
  padding: 0 5px;
}
.name{
  color: white;
}
.username{
  color: #aaa;
  font-size: 14px;
}
.user-but{
  grid-column: 3;
}
/* .user-more{
  grid-column: 4;
  text-align: center;
} */
button{
  font-size: 15px;
  font-weight: bold;
  border: 1px white solid;
  border-radius: 10px;
  /* padding: 10px 20px; */
}
</style>

<Auth bind:this="{auth}"></Auth>

<Dialog show="{showManage}" title="" height="{450}" buttons="{ [ {text: 'Cancel', callback: 'close', disabled: false, }, {text: 'Done', callback: 'done', disabled: false, }, ] }" on:close="{ () => showManage = false }" on:done="{ manageDoneHelper }">
  
  <div class="manage-photo">
    <img src="https://routes.hot0.workers.dev/fi/{localStorage.getItem('cookie')}/{localStorage.getItem('csrf')}/{manageUid}/{managePhoto}_m" class="manage-photo-pic" alt="user photo">
    <!-- <img src="/i/{managePhoto}" class="manage-photo-pic" alt="user photo"> -->
  </div>
  <div class="dialog-title">
    {manageName}
  </div>
  
  <div class="options">
    <div class="option11" on:click="{ () => showNotifications = !showNotifications }">Show Notifications</div>
    <div class="option21" on:click="{ () => showNotifications = !showNotifications }">
      {#if showNotifications}
        <i class="icon-checkmark-circle"></i>
      {:else}
        <i class="icon-circle"></i>
      {/if}
    </div>
    
    <div class="option12" on:click="{showUnfriendHelper}">Unfriend</div>
    <div class="option22" on:click="{showUnfriendHelper}">
      <i class="icon-circle"></i>
    </div>
    
    <div class="option13" on:click="{showBlockHelper}">Block</div>
    <div class="option23" on:click="{showBlockHelper}">
      <i class="icon-circle"></i>
    </div>
    
    <div class="option14" on:click="{ () => push('/friend-profile/' + manageUid) }">View Friend</div>
    <div class="option24" on:click="{ () => push('/friend-profile/' + manageUid) }">
      <i class="icon-arrow_right"></i>
    </div>
    
  </div>
  
</Dialog>


<DialogPopup show="{showUnfriend}" title="Unfriend" height="400" buttons="{ [ {text: 'Cancel', callback: 'close', disabled: false, }, {text: 'Unfriend', callback: 'done', disabled: false, }, ] }" on:close="{ () => showUnfriend = false }" on:done="{ unfriendHelper }">
  Are you sure you want to unfriend <strong>{manageName}</strong>?
</DialogPopup>


<DialogPopup show="{showBlock}" title="Block" height="400" buttons="{ [ {text: 'Cancel', callback: 'close', disabled: false, }, {text: 'Block', callback: 'done', disabled: false, }, ] }" on:close="{ () => showBlock = false }" on:done="{ blockUser }">
  Are you sure you want to block <strong>{manageName}</strong>?
</DialogPopup>


<Header back="{true}" on:back="{ () => pop() }">Friends</Header>
<div class="has-header"></div>

<Tabs items="{ [ { name: 'Friends', callback: 'friends', selected: true }, { name: 'Friend Requests', callback: 'friendRequests', selected: false }, { name: 'Requests Sent', callback: 'requestsSent', selected: false } ] }" on:friends="{ () => push('/friends-all') }" on:friendRequests="{ () => push('/friends-incoming') }" on:requestsSent="{ () => push('/friends-outgoing') }"></Tabs>

<!-- <div class="tabs">
  <div class="tab1 selected" on:click="{ () => push('/friends-all') }">Friends</div>
  <div class="tab2" on:click="{ () => push('/friends-incoming') }">Friend Requests</div>
  <div class="tab3" on:click="{ () => push('/friends-outgoing') }">Requests Sent</div>
</div> -->

<!-- <div on:click="{ () => showManage = true }">FriendsAll.svelte</div> -->

{#if items.length}
  
  {#each items as item, i }
    <div class="user" on:click="{ () => showManageBox(i) }">
      <div class="user-pic">
        <img src="https://routes.hot0.workers.dev/fi/{localStorage.getItem('cookie')}/{localStorage.getItem('csrf')}/{item.uid}/{item.photo}_m" class="photo" alt="user photo">
      </div>
      <div class="user-name">
        <div class="name">{item.name}</div>
        <div class="username">@{item.username}</div>
      </div>
      <div class="user-but"><button>Friends</button></div>
      <!-- <div class="user-more"><i class="icon-more2"></i></div> -->
    </div>
  {/each}

{:else}

  <h6>No Requests To Show Right Now</h6>

{/if}

<div class="has-action-bar"></div>
<ActionBar></ActionBar>


<script>

import {push, pop, replace, location, link} from 'svelte-spa-router';
export let params = {};

import Auth from "../interfaces/Auth.svelte";
let auth;

import ShareCrypto from "../helpers/ShareCrypto.js";

import Header from "../components/Header.svelte";
import ActionBar from "../components/ActionBar.svelte";
import Dialog from "../components/DialogSlide.svelte";
import DialogPopup from "../components/Dialog.svelte";
import Tabs from "../components/Tabs.svelte";

let showManage = false;
let manageIndex = -1;
let manageUid = "";
let manageName = "";
let managePhoto = "";
let showNotifications = true;

let showUnfriend = false;
let showBlock = false;

let items = [];


import { onMount } from "svelte";
onMount(async () => {
  load();
});


async function load() {
  
  let list = await auth.post("friendsAll", {});
  // console.log("list:", list);
  
  if (list.length > 0) {
    let files = await auth.post("loadFriendFiles", {files: list});
    
    files = JSON.parse(files);
    // console.log("files:", files);
    
    items = [];
    
    for (let i in files) {
      let friend = JSON.parse( ShareCrypto.decrypt(files[i]) );
      
      // console.log("friend:", friend);
      
      items.push( { uid: friend.uid, photo: friend.photoIds[0], name: friend.name, username: friend.username, showNotifications: true, blocked: false, } );
      
    }
  }
  
}


function showManageBox(index) {
  showManage = true;
  manageIndex = index;
  manageUid = items[index].uid;
  manageName = items[index].name;
  managePhoto = items[index].photo;
  showNotifications = items[index].showNotifications;
}


function manageDoneHelper() {
  
}


function showUnfriendHelper() {
  showManage = false;
  showUnfriend = true;
}


async function unfriendHelper() {
  showUnfriend = false;
  
  let rec = await auth.post("friendsUnfriend", {fuid: manageUid});
  load();
}


function showBlockHelper() {
  showManage = false;
  showBlock = true;
}


async function blockUser() {
  showBlock = false;
  await auth.post("friendsBlock", {fuid: manageUid});
  load();
}


function viewProfile() {
  
}


</script>